import React from "react";
import { useTheme } from "../DataContext";

export default function KPICard({ label, value, sub, color, icon, trend, onClick }) {
  const { theme } = useTheme();
  const c = color || theme.accent;
  return (
    <div
      className="pmo-card"
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        display: "flex", flexDirection: "column", gap: "6px",
        borderLeft: `3px solid ${c}`,
        transition: "transform 0.15s",
      }}
      onMouseEnter={e => { if (onClick) e.currentTarget.style.transform = "translateY(-2px)"; }}
      onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; }}
    >
      <div style={{
        display: "flex", alignItems: "flex-start",
        justifyContent: "space-between",
      }}>
        <div style={{
          fontSize: "10px", color: theme.textMuted,
          letterSpacing: "0.8px", textTransform: "uppercase",
          fontWeight: 600,
        }}>{label}</div>
        {icon && <span style={{ fontSize: "18px", color: `${c}88` }}>{icon}</span>}
      </div>
      <div style={{
        fontFamily: "'Orbitron', monospace",
        fontSize: "24px", fontWeight: 700, color: c,
        filter: `drop-shadow(0 0 8px ${c}44)`,
      }}>{value}</div>
      {sub && (
        <div style={{
          fontSize: "11px", color: theme.textMuted, display: "flex",
          alignItems: "center", gap: "4px",
        }}>
          {trend !== undefined && (
            <span style={{ color: trend >= 0 ? theme.success : theme.danger }}>
              {trend >= 0 ? "▲" : "▼"} {Math.abs(trend)}%
            </span>
          )}
          {sub}
        </div>
      )}
    </div>
  );
}
